export class TableCell {
    content: any;

    constructor(content: any) {
        this.content = content;
    }
}



// WEBPACK FOOTER //
// ./src/app/util/table-cell.ts